module.exports = __webpack_public_path__ + "static/img/v73DetailImg.be093f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v73DetailImg.png
// module id = bd10
// module chunks = 1